import { render } from "./ArtistDashboard.vue?vue&type=template&id=0bcc9baf&scoped=true"
import script from "./ArtistDashboard.vue?vue&type=script&lang=js"
export * from "./ArtistDashboard.vue?vue&type=script&lang=js"

import "./ArtistDashboard.vue?vue&type=style&index=0&id=0bcc9baf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcc9baf"]])

export default __exports__